import { StudentDebtQuestion } from '@hb/domain/steps/financial-obligation';
import { FinancialObligationsStoreService } from '@hb/modules/financial-obligations/financial-obligations-store.service';
import { FieldSubject } from '@hb/domain/field-subject';
import { money } from '@hb/builder';
import { AbstractStoreInjectOption } from '@hb/services/store/abstract-store-inject.service';

import { inject, Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { Money } from '@ap/interface-bspc-core';

@Injectable({
    providedIn: 'root'
})
export class StudentDebtStoreService extends AbstractStoreInjectOption<StudentDebtQuestion> implements OnDestroy {
    protected readonly store = inject(FinancialObligationsStoreService);
    protected readonly lastQuestion = StudentDebtQuestion.SUMMARY;

    private studentDebtSubscription: Subscription;
    private readonly amountSubject: FieldSubject<Money>;

    constructor() {
        super();
        this.init();

        this.amountSubject = new FieldSubject<Money>(this.getInitialValues());

        this.subscriptions();
    }

    update(): void {
        this.store.setStudentDebt(this.amountSubject.value);
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.studentDebtSubscription.unsubscribe();
        this.activeQuestionSubject.unsubscribe();
        this.amountSubject.unsubscribe();
    }

    getAmount(): Money {
        return this.amountSubject.value;
    }

    setAmount(amount: string): void {
        this.amountSubject.next(money(amount));
    }

    getInitialValues(): Money {
        return this.store.getFinancialObligationState()?.student_debt_amount;
    }

    private subscriptions(): void {
        this.amountSubject.asObservable().subscribe(() => this.update());
        this.studentDebtSubscription = this.store.getFinancialObligationsOptions().subscribe((options) => {
            if (!options.studentDebt) {
                this.amountSubject.next(null);
            }
        });
    }
}
